import { render, staticRenderFns } from "./RCard.vue?vue&type=template&id=77aa74dc&scoped=true&"
import script from "./RCard.vue?vue&type=script&lang=js&"
export * from "./RCard.vue?vue&type=script&lang=js&"
import style0 from "./RCard.vue?vue&type=style&index=0&id=77aa74dc&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "77aa74dc",
  null
  
)

export default component.exports